import React from "react";
import { Link, useLocation } from "react-router-dom";
import { ChevronRight } from "lucide-react";
import { useBreadcrumb } from "../context/BreadcrumbContext";
import { useAuth } from "../../../context/AuthContext";

interface BreadcrumbItemProps {
  pathname: string;
  routeTo: string;
  isLast: boolean;
  index: number;
}

const BreadcrumbItem: React.FC<BreadcrumbItemProps> = ({
  pathname,
  routeTo,
  isLast,
  index,
}) => {
  const location = useLocation();
  const { getBreadcrumbConfig } = useBreadcrumb();
  const { user } = useAuth();

  const roleName = user?.role?.nome?.toLowerCase() || "";
  const isRoterista = roleName === "roterista";

  const allowedRoutesForRoterista = [
    "/roterista",
    "/roterista-automatico",
    "/meu-perfil",
  ];

  const config = getBreadcrumbConfig(pathname);
  const displayName = config?.name || pathname;
  const icon = config?.icon;

  const isHomePath =
    location.pathname === "/dashboard" ||
    location.pathname === "/pizzaiolo" ||
    location.pathname === "/entregadores" ||
    location.pathname === "/roterista" ||
    location.pathname === "/roterista-automatico";
  const showSeparator = !isHomePath || index > 0;

  const isRouteAllowed =
    !isRoterista || allowedRoutesForRoterista.includes(routeTo);

  return (
    <li className="flex items-center">
      {showSeparator && (
        <ChevronRight size={16} className="mx-2 text-neutral-400" />
      )}
      {isLast ? (
        <span className="flex items-center gap-2 font-medium text-neutral-500">
          {icon}
          <span>{displayName}</span>
        </span>
      ) : isRouteAllowed ? (
        <Link
          to={routeTo}
          className="flex items-center gap-2 text-neutral-500 hover:text-neutral-700"
        >
          {icon}
          <span>{displayName}</span>
        </Link>
      ) : (
        <span className="flex cursor-not-allowed items-center gap-2 text-neutral-400">
          {icon}
          <span>{displayName}</span>
        </span>
      )}
    </li>
  );
};

export default BreadcrumbItem;
